const appApplicationGroups = [
  {
    id: "admin",
    value: "Admin",
    group: "Admin",
    appType: "IAP"
  },
  {
    id: "marketAdmin",
    value: "Market Admin",
    group: "MarketAdmin",
    appType: "IAP"
  },
  {
    id: "contentManager",
    value: "Content Manager",
    group: "ContentManager",
    appType: "IAP"
  },
  {
    id: "applicationManager",
    value: "Application Manager",
    group: "ApplicationManager",
    appType: "IAP"
  },
  {
    id: "fleetManager",
    value: "Fleet Manager",
    group: "FleetManager",
    appType: "IAP"
  },
  {
    id: "reporter",
    value: "Reporter",
    group: "Reporter",
    appType: "IAP"
  }
];

export default appApplicationGroups;
